import { render, staticRenderFns } from "./WallboxPrintpage2.vue?vue&type=template&id=58cbd14c"
import script from "./WallboxPrintpage2.vue?vue&type=script&lang=js"
export * from "./WallboxPrintpage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports